export const data: any = {
  NEXT_PUBLIC_SITE_MACHINE_NAME: "corporate",
  NEXT_PUBLIC_CF_MXP_SPACE_ID: "f1e2584ztjpk",
  NEXT_PUBLIC_CF_MXP_ENVIRONMENT: "master",
  NEXT_PUBLIC_CF_RC_ENVIRONMENT: "e2e-test",
  NEXT_PUBLIC_ALGOLIA_SITE_INDEX: "global-production",
  BYPASS_CONSENT_CHECK: true
}
